// @flow
import React from 'react'

const ScaleDown = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 23 23">
      <g fill="none" fillRule="evenodd" stroke="#6E7B8C">
        <path strokeLinecap="square" d="M22.5 7.5h-7v-7" />
        <path strokeLinecap="square" d="M22.5 22.5H.5V.5h22z" />
        <path d="M12.5 10.5l-8 8" />
        <path strokeLinecap="square" d="M4.5 11.5v7h7" />
      </g>
    </svg>
  )
}

export default ScaleDown



// WEBPACK FOOTER //
// ./src/components/Icons/ScaleDown.js